
const Config = {
  name: 'Matrículas',
  api: {
    uri: {
      production: 'https://joy-production.classapp.co/graphql',
      stage: 'https://joy-stage.classapp.ninja/graphql',
      internal: 'https://joy-internal.classapp.ninja/graphql',
      development: 'http://localhost:2000/graphql',
    }
  },
  webUploadApi: {
    uri: {
      production: 'https://web-upload.classapp.com.br',
      stage: 'https://web-stage-upload.classapp.ninja',
      internal: 'https://web-internal-upload.classapp.ninja',
      development: 'http://localhost:2000',
    }
  },
  walle: {
    uri: {
      production: 'https://classapp.co/',
      stage: 'http://classapp.ninja/',
      internal: 'http://walle-internal.classapp.ninja/',
      development: 'http://localhost:5400/',
    }
  },
  s3: {
    production: 'https://classapp-live-media-1.s3.amazonaws.com/',
    stage: 'https://classapp-stage-media-1.s3.amazonaws.com/',
    internal: 'https://classapp-internal-media-1.s3.amazonaws.com/',
    development: 'https://classapp-local-media-1.s3.amazonaws.com/'
  },
  authClientId: '8357649ef18ac7a6191d06ca7d0873218a61ae5fac2f6104b74796a104102441',
  installClientId: '8357649ef18ac7a6191d06ca7d0873218a61ae5fac2f6104b74796a104102441',
  walleClientId: 'ZmYyYWM3M2JmYjkxY2IwZWJhNzlhZjcw',
  loginRedirect: {
    development: 'http://localhost:5500',
    stage: 'https://krabs.classapp.ninja',
    internal: 'https://krabs-internal.classapp.ninja',
    production: 'https://financeiro.classapp.com.br'
  },
  assets: {
    development: '/static/',
    stage: 'https://krabs-stage-assets.s3-us-west-2.amazonaws.com/assets/',
    internal: 'https://krabs-internal-assets.s3-us-west-2.amazonaws.com/assets/',
    production: 'https://krabs-production-assets.s3-us-west-2.amazonaws.com/assets/'
  },
  terms:
  {
    enrollment: 'https://krabs-production-assets.s3-us-west-2.amazonaws.com/terms.pdf',
    payment: 'https://uploads-ssl.webflow.com/5cf6646fb1bedb1cac953e0c/5f330a328fa5cbf9f077e0df_Termo-pagamentos.pdf'
  },
  minimum_currency: 2.9,
  currency: {
    USD: { label: 'U$', decimalSeparator: '.', thousandSeparator: ',' },
    BRL: { label: 'R$', decimalSeparator: ',', thousandSeparator: '.' }
  },
  loginUri: { development: '', stage: '', production: '', internal: '' }
};

Config.loginUri = {
  development: `http://localhost:5400/oauth/authorize?client_id=${Config.authClientId}&redirect_uri=${Config.loginRedirect.development}`,
  stage: `http://classapp.ninja/oauth/authorize?client_id=${Config.authClientId}&redirect_uri=${Config.loginRedirect.stage}`,
  internal: `http://walle-internal.classapp.ninja/oauth/authorize?client_id=${Config.authClientId}&redirect_uri=${Config.loginRedirect.internal}`,
  production: `https://classapp.com.br/oauth/authorize?client_id=${Config.authClientId}&redirect_uri=${Config.loginRedirect.production}`,
};

/* Config.installUri = {
  development: `http://localhost:5400/oauth/authorize?client_id=${Config.installClientId}&redirect_uri=${Config.installRedirect.development}`,
  stage: `http://classapp.ninja/oauth/authorize?client_id=${Config.installClientId}&redirect_uri=${Config.installRedirect.stage}`,
  production: `http://classapp.com.br/oauth/authorize?client_id=${Config.installClientId}&redirect_uri=${Config.installRedirect.production}`,
}; */

export default Config;
